import api from './api'

// Phân luồng lead tự động (luân phiên) — admin only
const autoAssignService = {
  async get() {
    const response = await api.get('/auto-assign')
    return response.data
  },

  // body: { enabled?, members?: [{ user_id, is_active }] (đúng thứ tự), next_user_id? }
  async save(body) {
    const response = await api.put('/auto-assign', body)
    return response.data
  },
}

export default autoAssignService
